import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
 HttpEvent,
 HttpInterceptor,
 HttpHandler,
 HttpRequest,
 HttpResponse,
 HttpErrorResponse,
} from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {InstiService} from './insti.service';
import { retry } from 'rxjs/operators'; 
import { catchError } from 'rxjs/operators'; 
import { throwError } from 'rxjs'; 
import Swal from 'sweetalert2'
import { instiRoutehandle } from './instiRoutehandle.module';
//@Injectable()
const insti_service =InstiService;

export class HttpsRequestInterceptor implements HttpInterceptor {
  constructor(private insti_route: instiRoutehandle,
              protected service: InstiService) {
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if(req.url=='xxx'){
    }

    if(req.params.get('isExternal') == 'true'){
      return next.handle(req);
    }
    
    var inst_class=new insti_service();
    
    
    const dupReq = req.clone({
        //// if(req.method=='POST'){
          
    headers: req.headers
      .set('Authorization','Bearer '+inst_class.getUser().getAuthorization())
      .set('X-XSRF-TOKEN', inst_class.getCsrToken())
      .set('Content-Type','application/json; charset=utf-8'),
    params: req.params.set('_token', inst_class.getCsrToken()),
  });

  let instance = this;
  return next.handle(dupReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 301) {
        instance.insti_route.getRoutObj().navigate([instance.service.getLoginUrl(true)]);
        Swal.fire({
          title: "Atenção!",
          html:"Token inválido. Faça o login novamente.",
          type: "warning",
          showCancelButton: false,
          showConfirmButton: true,
        });
      }
      if (error.status === 419) {
        instance.insti_route.getRoutObj().navigate([instance.service.getLoginUrl(true)]);
        Swal.fire({
          title: "Atenção!",
          html:"Token expirado. Faça o login novamente.",
          type: "warning",
          showConfirmButton: true,
        });
      }
      if (error.status === 307) {
        instance.insti_route.getRoutObj().navigate(['gestao-condominio/empresa-filial']);
        Swal.fire({
          title: "Atenção!",
          html: error.error['msg'],
          type: "warning",
          showCancelButton: false,
          showConfirmButton: true,
        });
      }
      return throwError(error);
    })
  );



  }
}
    
    
@NgModule({
providers: [
 {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpsRequestInterceptor,
  multi: true,
 },
],
})
    
    
export class Interceptor {}
